import type { EventEmitter, TemplateRef } from '@angular/core';
import { InjectionToken } from '@angular/core';
import type { MenuPositionX, MenuPositionY } from './menu-positions';
import type { Direction } from '@angular/cdk/bidi';
import type { FocusOrigin } from '@angular/cdk/a11y';
import type { MatMenuContentDirective } from './menu-content.directive';

/**
 * Injection token used to provide the parent menu to menu-specific components.
 */
export const MAT_MENU_PANEL = new InjectionToken<MatMenuPanel>('MAT_MENU_PANEL');

/**
 * Interface for a custom menu panel that can be used with `matMenuTriggerFor`.
 */
export interface MatMenuPanel {
  xPosition: MenuPositionX;
  yPosition: MenuPositionY;
  overlapTrigger: boolean;
  templateRef: TemplateRef<any>;
  readonly close: EventEmitter<void | 'click' | 'keydown' | 'tab'>;
  parentMenu?: MatMenuPanel | undefined;
  direction?: Direction;
  focusFirstItem: (origin?: FocusOrigin) => void;
  resetActiveItem: () => void;
  setPositionClasses?: (x: MenuPositionX, y: MenuPositionY) => void;
  setElevation?(depth: number): void;
  lazyContent?: MatMenuContentDirective;
  backdropClass?: string;
  overlayPanelClass?: string | string[];
  hasBackdrop?: boolean;
  readonly panelId?: string;
}
